import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./registrationDialogNoProperty.html')
})
export class RegistrationNoPropertyDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationNoPropertyDialog>) public dialogRef: MatDialogRef<RegistrationNoPropertyDialog>) {}

    closeThisDialog(value: any){
        this.dialogRef.close(value)
    }
}
